import { render, staticRenderFns } from "./MetricValue.vue?vue&type=template&id=6b49c2a6"
import script from "./MetricValue.vue?vue&type=script&setup=true&lang=ts"
export * from "./MetricValue.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.26.0__cache-loader@4.1.0_webpack@4_duly6tfyc62fvcli236pnhbyri/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./MetricValue.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MetricsFormattedMetricValue: require('/home/runner/work/assessment-service/assessment-service/frontend/components/metrics/FormattedMetricValue.vue').default})
